import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';

import QueryErrorState from 'components/DesignSystem/QueryErrorState';
import QueryCard from 'components/Meteorology/Shared/QueryCard';
import QueryCardHeader from 'components/Meteorology/Shared/QueryCard/Header';
import QueryCardChips from 'components/Meteorology/Shared/QueryCard/Chips';
import QueryCardChip from 'components/Meteorology/Shared/QueryCard/Chip';
import QueryCardTrigger from 'components/Meteorology/Shared/QueryCard/Trigger';
import ImageColumns from 'components/Meteorology/Shared/ImageColumns';
import { DisplayImage } from 'helper/products/meteorology';
import { ResponseError } from 'services/api/base';
import {
  selectMFComparatorControlPanelConfrontationalModel,
  selectMFComparatorControlPanelSubtitle,
  selectMFComparatorControlPanelTitle,
} from 'redux/reducers/meteorologyFieldsComparatorControlPanelReducer';
import EmptyState from './EmptyState';
import PeriodPills from './PeriodPills';
import ControlPanelSheet, { ControlPanelSheetTab } from './ControlPanelSheet';

import './index.scss';

export default function ComparatorMobile({
  showInstructions,
  imageSets,
  columnLabels,
  rowLabels,
  onDownloadClick,
  downloadDisabled,
  isLoading,
  isFetching,
  queryError,
}: {
  showInstructions: boolean;
  imageSets: DisplayImage[][];
  columnLabels: string[];
  rowLabels: string[];
  onDownloadClick: () => void;
  downloadDisabled: boolean;
  isLoading: boolean;
  isFetching: boolean;
  queryError: ResponseError | undefined;
}) {
  const [sheetOpen, setSheetOpen] = useState(false);
  const [sheetTab, setSheetTab] = useState<ControlPanelSheetTab>('comparacoes');
  const title = useSelector(selectMFComparatorControlPanelTitle);
  const subtitle = useSelector(selectMFComparatorControlPanelSubtitle);
  const confrontationalModel = useSelector(selectMFComparatorControlPanelConfrontationalModel);

  const openSheet = (tab: ControlPanelSheetTab) => {
    setSheetTab(tab);
    setSheetOpen(true);
  };

  if (showInstructions) {
    return (
      <>
        <EmptyState onStart={() => openSheet('comparacoes')} />
        <ControlPanelSheet
          open={sheetOpen}
          dismiss={() => setSheetOpen(false)}
          defaultTab={sheetTab}
        />
      </>
    );
  }

  return (
    <div className="comparator-mobile">
      <QueryCard>
        {title && (
          <QueryCardHeader label={title} title={subtitle}>
            {confrontationalModel && (
              <QueryCardChips>
                <QueryCardChip accent dot>{confrontationalModel}</QueryCardChip>
              </QueryCardChips>
            )}
          </QueryCardHeader>
        )}

        <div className="comparator-mobile-period-section">
          <span className="comparator-mobile-period-label">Período</span>
          <PeriodPills onDownloadClick={onDownloadClick} downloadDisabled={downloadDisabled} />
        </div>

        <QueryCardTrigger
          onClick={() => openSheet('comparacoes')}
          hint="Comparações · Preferências · Nova"
        />
      </QueryCard>

      {queryError && (
        <QueryErrorState title={queryError.data} message={queryError.description} />
      )}
      {!queryError && isLoading && (
        <div className="text-center py-4"><Spinner /></div>
      )}
      {!queryError && !isLoading && (
        <>
          <ImageColumns imageSets={imageSets} columnLabels={columnLabels} rowLabels={rowLabels} />
          {isFetching && <div className="text-center py-4"><Spinner /></div>}
        </>
      )}

      <ControlPanelSheet
        open={sheetOpen}
        dismiss={() => setSheetOpen(false)}
        defaultTab={sheetTab}
      />
    </div>
  );
}
